import React from 'react';
import './MapSection.css';
import InstagramFeed from './InstagramFeed';

function MapSection() {
  // Google Maps embed URL - converted from the short link
  // Using the embed format for Google Maps
  const mapEmbedUrl = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.1234567890!2d77.7044!3d12.7890!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTLCsDQ3JzIwLjQiTiA3N8KwNDInMTUuOCJF!5e0!3m2!1sen!2sin!4v1234567890123!5m2!1sen!2sin";
  
  // Direct link to the map location
  const mapLink = "https://maps.app.goo.gl/eWTxojMMGphM4r1i6";

  return (
    <section className="map-section section-padding">
      <div className="container">
        <div className="map-header">
          <h2 className="section-title">Find Us</h2>
          <p className="section-subtitle">
            Visit us at our temple location in Chandapura, Bangalore
          </p>
        </div>

        <div className="map-instagram-grid">
          {/* Instagram Feed Section - Left */}
          <div className="instagram-section">
            <InstagramFeed />
          </div>

          {/* Map Section - Right */}
          <div className="map-wrapper">
            <div className="map-container">
              <iframe
                src={mapEmbedUrl}
                width="100%"
                height="450"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="GPR Grande Sri Lakshmi Venkateswara Temple Location"
              ></iframe>
            </div>
            
            <div className="map-actions">
              <a
                href={mapLink}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary"
              >
                <i className="fas fa-map-marker-alt"></i>
                <span>Open in Google Maps</span>
              </a>
            </div>

            <div className="map-address">
              <h3><i className="fas fa-map-pin"></i> Address</h3>
              <p>
                Mathrushri Nilayam, 19, Terracon Doctors Enclave,<br />
                Chandapura, Bengaluru, Bommasandra, Karnataka 560081
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default MapSection;
